export default "__VITE_ASSET__49fb9f3f__"